/*
  Fonts for world-space text, mirroring the DOM UI. troika needs the files
  themselves rather than a CSS face, and rejects woff2, so these are ttf.
  Self-hosted in public/Fonts — no runtime dependency on Google's CDN.
*/
export const SCENE_FONT = '/Fonts/Outfit-Regular.ttf';

export const SCENE_FONT_MONO = '/Fonts/JetBrainsMono-Regular.ttf';
